import { useCopyScoreDisplayToReports } from './useScoreDisplay';
import { useCopyShowNamesToReports } from './useShowNames';
import { useCopyShowResponseToReport } from './useShowResponses';
import { useCopyShowResultsToReport } from './useShowResults';
import { useCopyShowTimersToReports } from './useShowTimers';

export function useCopyAllToReports() {
  const copyShowResultsToReport = useCopyShowResultsToReport();
  const copyShowNamesToReports = useCopyShowNamesToReports();
  const copyShowResponseToReport = useCopyShowResponseToReport();
  const copyScoreDisplayToReports = useCopyScoreDisplayToReports();
  const copyShowTimersToReports = useCopyShowTimersToReports();

  return () => {
    copyShowResultsToReport();
    copyShowNamesToReports();
    copyShowResponseToReport();
    copyScoreDisplayToReports();
    copyShowTimersToReports();
  };
}
